import { FormatAdress } from './address-format.service';

export default angular
  .module('sfMobile.services.address-format', [])
  .service('addressFormat', () => FormatAdress).name;
